// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"UnsubscribeView_Wrapper__1fW3U","ValidationError":"UnsubscribeView_ValidationError__1usj1","Success":"UnsubscribeView_Success__3Y71U"};